import script from "./OnboardingPersonalInfosForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingPersonalInfosForm.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingPersonalInfosForm.vue?vue&type=style&index=0&id=94d5094e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d5094e"]])

export default __exports__